import AccountTreeIcon from "@mui/icons-material/AccountTree";
import BadgeIcon from "@mui/icons-material/Badge";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Alert, Box, Button, Card, CardContent, Checkbox, Divider, Grid, ListItemText, MenuItem, Snackbar, TextField, Typography } from '@mui/material';
import InputAdornment from "@mui/material/InputAdornment";
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPredictedCollegesCount } from '../services/CollegePredictorServices/aiCollegePredictorService';

function CollegePredictorReportDashboard() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const downloadPreferenceRef = useRef(null);
    console.log("location state1:", state);
    let data = state?.filters;
    console.log(data, '-filtersdata')

    const initialFilters = state?.filters;
    const [filters, setFilters] = useState(() => ({
        ...initialFilters,
        preferredBranch: initialFilters?.preferredBranch || [],
        preferredLocation: initialFilters?.locationPreference || [],
        name: state?.name || "",
        email: state?.email || "",
    }));
    console.log(filters, '-filtersdata', state, 'state')
    // const [filters, setFilters] = useState(initialFilters);

    const [sampleColleges, setSampleColleges] = useState([]);

    const [collegeCount, setCollegeCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [showError, setShowError] = useState([]);
    const [severty, setSeverty] = useState('warning');
    const [editCount, setEditCount] = useState(0);

    const [isPdfCreated, setIsPdfCreated] = useState(false);

    const [selectedBranchGroups, setSelectedBranchGroups] = useState([]);
    const [selectedLocationGroups, setSelectedLocationGroups] = useState([]);
    const [loadingPrediction, setLoadingPrediction] = useState(false);
    const [generatingPdf, setGeneratingPdf] = useState(false);
    const MAX_EDIT = 3;

    const MIN_COLLEGES_REQUIRED = 25;
    const canDownloadPdf =
        collegeCount >= MIN_COLLEGES_REQUIRED ||
        editCount >= MAX_EDIT;
    const branchOptions = [
        {
            value: "Aeronautical & Automotive",
            label: "Aeronautical & Automotive (All Related Branches)",
            branches: ["Aeronautical & Automotive"],
        },
        {
            value: "Computer",
            label: "Computer (All Related Branches)",
            branches: [
                "Computer",
                "Information Technology",
                "AI & Data Science",
                "Cyber Security & IoT",
            ],
        },
        {
            value: "Electronics & Communication",
            label: "Electronics & Communication (All Related Branches)",
            branches: [
                "Electronics & Communication",
                "Electrical & Electronics",
            ],
        },
        {
            value: "Mechanical",
            label: "Mechanical (All Related Branches)",
            branches: [
                "Mechanical",
                "Mechatronics & Robotics",
            ],
        },
        {
            value: "Civil",
            label: "Civil (All Related Branches)",
            branches: ["Civil"],
        },
    ];

    const locationOptions = [
        {
            value: "Amravati",
            label: "Amravati",
            cities: [
                "Amravati",
                "Badnera"
            ],
        },
        {
            value: "Aurangabad",
            label: "Chh.Sambhajinagar",
            cities: [
                "Aurangabad",
                "Sambhajinagar"
            ],
        },
        {
            value: "Kolhapur",
            label: "Kolhapur",
            cities: [
                "Kolhapur",
                "Gadhinglaj",
                "Ichalkaranji",
                "Panhala",
                "Warananagar"
            ],
        },
        {
            value: "Mumbai",
            label: "Mumbai",
            cities: [
                "Mumbai",
                "Andheri",
            ],
        },
        {
            value: "Navi Mumbai",
            label: "Navi Mumbai",
            cities: ["Navi Mumbai"],
        },
        {
            value: "Nagpur",
            label: "Nagpur",
            cities: [
                "Nagpur",
                "Ramtek"
            ],
        },
        {
            value: "Nashik",
            label: "Nashik",
            cities: [
                "Nashik",
                "Malegaon",
                "Sinnar"
            ],
        },
        {
            value: "Pune",
            label: "Pune",
            cities: [
                "Pune",
                "Baramati",
                "Bhor",
                "Haveli",
                "Indapur",
                "Lonavala",
                "Avasari",
                "Bhima",
                "Dumbarwadi",
                "Lakhewadi",
                "Pisoli",
                "Ravet",
                "Sasewadi",
                "Someshwar Nagar",
                "Talegaon",
                "Vadgaon",
                "Wagholi",
                "Yelgaon"
            ],
        },
        {
            value: "Solapur",
            label: "Solapur",
            cities: [
                "Solapur",
                "Barshi",
                "Pandharpur",
                "Sangola"
            ],
        },
        {
            value: "Sangli",
            label: "Sangli",
            cities: [
                "Sangli",
                "Akluj",
                "Jaysingpur",
                "Miraj"
            ],
        }
    ];

    const loadPrediction = async (currentFilters = filters) => {
        if (!currentFilters.rank) {
            return;
        }
        setLoadingPrediction(true);
        try {
            const response = await getPredictedCollegesCount(
                "pcm",
                currentFilters.rank,
                currentFilters.preferredBranch ?? ["All"],
                currentFilters.category,
                currentFilters.preferredLocation ?? ["All"],
                currentFilters.genderType,
                "All",
                true
            );

            setCollegeCount(response.count);
            setSampleColleges(response.sampleData || []);
        } catch (err) {
            console.log(err);
        } finally {
            setLoadingPrediction(false);
        }
    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
        setShowError("");
    };
    useEffect(() => {
        if (filters?.rank) {
            setOpen(true);
            setShowError("Payment Successful for Personalized Preference List");
            setSeverty('success');
        }
        if (filters?.rank && downloadPreferenceRef.current) {
            setTimeout(() => {
                downloadPreferenceRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }, 300);
        }
    }, [filters?.rank]);

    useEffect(() => {
        if (!filters) return;

        const initialBranchGroups = branchOptions
            .filter(option =>
                option.branches.some(branch =>
                    filters.preferredBranch?.includes(branch)
                )
            )
            .map(option => option.value);

        const initialLocationGroups = locationOptions
            .filter(option =>
                option.cities.some(city =>
                    filters.preferredLocation?.includes(city)
                )
            )
            .map(option => option.value);

        setSelectedBranchGroups(initialBranchGroups);
        setSelectedLocationGroups(initialLocationGroups);

        const updatedFilters = {
            ...filters,
            preferredBranch:
                initialBranchGroups.length > 0
                    ? branchOptions
                        .filter(b => initialBranchGroups.includes(b.value))
                        .flatMap(b => b.branches)
                    : ["All"],

            preferredLocation:
                initialLocationGroups.length > 0
                    ? locationOptions
                        .filter(l => initialLocationGroups.includes(l.value))
                        .flatMap(l => l.cities)
                    : ["All"],
        };

        setFilters(updatedFilters);

        loadPrediction(updatedFilters);
    }, []);
    const handleCreatePdf = async () => {
        console.log("location state2:", state);
        setGeneratingPdf(true);
        setIsPdfCreated(true);
        navigate("/cpreport", { state: { filters: filters, name: filters?.name, email: filters?.email } });
    };
    const getSelectedBranches = () => {
        if (!selectedBranchGroups.length)
            return filters.preferredBranch?.length
                ? filters.preferredBranch
                : ["All"];

        return branchOptions
            .filter(x => selectedBranchGroups.includes(x.value))
            .flatMap(x => x.branches);
    };

    const getSelectedLocations = () => {
        if (!selectedLocationGroups.length)
            return filters.preferredLocation?.length
                ? filters.preferredLocation
                : ["All"];

        return locationOptions
            .filter(x => selectedLocationGroups.includes(x.value))
            .flatMap(x => x.cities);
    };
    // const getSelectedBranches = () => {

    //     if (selectedBranchGroups.length === 0)
    //         return ["All"];

    //     return branchOptions
    //         .filter(x => selectedBranchGroups.includes(x.value))
    //         .flatMap(x => x.branches);

    // };
    // const getSelectedLocations = () => {

    //     if (selectedLocationGroups.length === 0)
    //         return ["All"];

    //     return locationOptions
    //         .filter(x => selectedLocationGroups.includes(x.value))
    //         .flatMap(x => x.cities);

    // };
    const handleApplyFilters = async () => {

        if (editCount >= MAX_EDIT) return;

        const branches = getSelectedBranches();
        const locations = getSelectedLocations();

        const isSame =
            JSON.stringify(branches) === JSON.stringify(filters.preferredBranch) &&
            JSON.stringify(locations) === JSON.stringify(filters.preferredLocation);

        if (isSame) return;

        const updatedFilters = {
            ...filters,
            preferredBranch: branches,
            preferredLocation: locations
        };

        setFilters(updatedFilters);
        setEditCount(prev => prev + 1);

        await loadPrediction(updatedFilters);
    };
    const disableFilters =
        editCount >= MAX_EDIT || isPdfCreated;

    return (
        filters?.rank ?
            (<Box
                sx={{
                    minHeight: "100vh",
                    bgcolor: "#f5f7fb",
                    py: 6,
                }}
            >
                <Box textAlign="center" mb={4}>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: "2.4rem",
                                md: "3.2rem"
                            },
                            fontWeight: 700,
                            color: "#242e42"
                        }}
                    >
                        Get Your <span style={{ color: '#f08021' }}>Personalized Preference List!</span>
                    </Typography>

                    <Typography
                        sx={{
                            mt: 1,
                            color: "#032d56",
                            fontSize: "1.5rem",
                            fontWeight: 600,
                        }}
                    >
                        Review your preferences before generating the PDF report.
                    </Typography>

                </Box>
                <Card
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        overflow: "hidden",
                        boxShadow: "0px 20px 50px rgba(15,23,42,.08)"
                    }}
                >
                    <CardContent
                        sx={{
                            p: {
                                xs: 3,
                                md: 4
                            }
                        }}
                    >
                        <Box
                            sx={{
                                maxWidth: 900,
                                mx: "auto",
                            }}
                        >

                            <Grid container spacing={2}>

                                {/* Rank */}

                                <Grid item xs={12} md={4}>

                                    <Typography
                                        sx={{
                                            mb: 1,
                                            fontSize: "1.4rem",
                                            fontWeight: 600,
                                            color: "#242e42",
                                            textAlign: 'left'
                                        }}
                                    >
                                        Your Rank
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        disabled
                                        value={filters.rank}
                                        sx={{
                                            "& .MuiSelect-select": {
                                                fontSize: "1.5rem",
                                            },
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: (
                                                <InputAdornment position="start">

                                                    <Box
                                                        sx={{
                                                            width: 34,
                                                            height: 34,
                                                            bgcolor: "#E8F0FE",
                                                            borderRadius: 2,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >
                                                        <TrendingUpIcon
                                                            sx={{
                                                                color: "#1447ad",
                                                                fontSize: "1.7rem"
                                                            }}
                                                        />
                                                    </Box>

                                                </InputAdornment>
                                            ),

                                            // endAdornment: (
                                            //     <InputAdornment position="end">
                                            //         <LockOutlinedIcon
                                            //             sx={{ color: "#94A3B8" }}
                                            //         />
                                            //     </InputAdornment>
                                            // )
                                        }}
                                    />

                                    {/* <Typography
                                    sx={{
                                        mt: 1,
                                        fontSize: "1.1rem",
                                        color: "#6B7280"
                                    }}
                                >
                                    Rank is locked from submitted details.
                                </Typography> */}

                                </Grid>

                                {/* Category */}

                                <Grid item xs={12} md={4}>

                                    <Typography
                                        sx={{
                                            mb: 1,
                                            fontSize: "1.4rem",
                                            fontWeight: 600,
                                            color: "#242e42",
                                            textAlign: 'left'
                                        }}
                                    >
                                        Category
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        disabled
                                        value={filters.category}
                                        sx={{
                                            border: 'none', "& .MuiSelect-select": {
                                                fontSize: "1.5rem",
                                            },
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: (
                                                <InputAdornment position="start">

                                                    <Box
                                                        sx={{
                                                            width: 34,
                                                            height: 34,
                                                            bgcolor: "#FFF3E8",
                                                            borderRadius: 2,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >
                                                        <BadgeIcon
                                                            sx={{
                                                                color: "#F08021",
                                                                fontSize: "1.7rem"
                                                            }}
                                                        />
                                                    </Box>

                                                </InputAdornment>
                                            ),

                                            // endAdornment: (
                                            //     <InputAdornment position="end">
                                            //         <LockOutlinedIcon
                                            //             sx={{ color: "#94A3B8" }}
                                            //         />
                                            //     </InputAdornment>
                                            // )
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12} md={4}>

                                    <Typography
                                        sx={{
                                            mb: 1,
                                            fontSize: "1.4rem",
                                            fontWeight: 600,
                                            color: "#242e42",
                                            textAlign: 'left'
                                        }}
                                    >
                                        Seat Type
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        disabled
                                        value={filters?.genderType
                                            ? filters?.genderType?.charAt(0)?.toUpperCase() + filters?.genderType?.slice(1)
                                            : ""}
                                        sx={{
                                            border: 'none', "& .MuiSelect-select": {
                                                fontSize: "1.5rem",
                                            },
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: (
                                                <InputAdornment position="start">

                                                    <Box
                                                        sx={{
                                                            width: 34,
                                                            height: 34,
                                                            bgcolor: "#FFF3E8",
                                                            borderRadius: 2,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >
                                                        <BadgeIcon
                                                            sx={{
                                                                color: "#F08021",
                                                                fontSize: "1.7rem"
                                                            }}
                                                        />
                                                    </Box>

                                                </InputAdornment>
                                            ),
                                        }}
                                    />

                                </Grid>

                            </Grid>
                            <Grid container spacing={2} mt={1}>

                                {/* Branch */}

                                <Grid item xs={12} md={6}>

                                    <Typography
                                        sx={{
                                            mb: 1,
                                            fontSize: "1.4rem",
                                            fontWeight: 600,
                                            color: "#242e42",
                                            textAlign: 'left'
                                        }}
                                    >
                                        Preferred Branches
                                    </Typography>


                                    <TextField
                                        select
                                        fullWidth
                                        value={selectedBranchGroups}
                                        disabled={disableFilters}
                                        SelectProps={{
                                            multiple: true,
                                            renderValue: (selected) =>
                                                selected.join(", "),
                                            MenuProps: {
                                                PaperProps: {
                                                    sx: {
                                                        "& .MuiMenuItem-root": {
                                                            fontSize: "1.4rem",
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                        onChange={(e) =>
                                            setSelectedBranchGroups(e.target.value)
                                        }
                                        sx={{
                                            bgcolor: "grey.50",
                                            borderRadius: 2,
                                            "& .MuiSelect-select": {
                                                fontSize: "1.4rem",
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">

                                                    <Box
                                                        sx={{
                                                            width: 34,
                                                            height: 34,
                                                            bgcolor: "#F3E8FF",
                                                            borderRadius: 2,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >
                                                        <AccountTreeIcon
                                                            sx={{
                                                                color: "#7C3AED",
                                                                fontSize: "1.7rem"
                                                            }}
                                                        />
                                                    </Box>

                                                </InputAdornment>
                                            )
                                        }}
                                    >

                                        {branchOptions.map(option => (

                                            <MenuItem
                                                key={option.value}
                                                value={option.value}
                                            >

                                                <Checkbox
                                                    checked={
                                                        selectedBranchGroups.includes(option.value)
                                                    }
                                                />

                                                <ListItemText
                                                    primary={option.label}
                                                />

                                            </MenuItem>

                                        ))}

                                    </TextField>


                                </Grid>
                                {/* City */}

                                <Grid item xs={12} md={6}>

                                    <Typography
                                        sx={{
                                            mb: 1,
                                            fontSize: "1.4rem",
                                            fontWeight: 600,
                                            color: "#242e42",
                                            textAlign: 'left'
                                        }}
                                    >
                                        Preferred Cities
                                    </Typography>


                                    <TextField
                                        select
                                        fullWidth
                                        value={selectedLocationGroups}
                                        disabled={disableFilters}
                                        SelectProps={{
                                            multiple: true,
                                            renderValue: (selected) =>
                                                selected.join(", "),
                                            MenuProps: {
                                                PaperProps: {
                                                    sx: {
                                                        "& .MuiMenuItem-root": {
                                                            fontSize: "1.4rem",
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                        onChange={(e) =>
                                            setSelectedLocationGroups(e.target.value)
                                        }
                                        sx={{
                                            bgcolor: "grey.50",
                                            borderRadius: 2,
                                            "& .MuiSelect-select": {
                                                fontSize: "1.4rem",
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">

                                                    <Box
                                                        sx={{
                                                            width: 34,
                                                            height: 34,
                                                            bgcolor: "#F3E8FF",
                                                            borderRadius: 2,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >

                                                        <LocationOnIcon
                                                            sx={{
                                                                color: "#7C3AED",
                                                                fontSize: "1.7rem"
                                                            }}
                                                        />

                                                    </Box>

                                                </InputAdornment>
                                            )
                                        }}
                                    >

                                        {locationOptions.map(option => (

                                            <MenuItem
                                                key={option.value}
                                                value={option.value}
                                            >

                                                <Checkbox
                                                    checked={
                                                        selectedLocationGroups.includes(option.value)
                                                    }
                                                />

                                                <ListItemText
                                                    primary={option.label}
                                                />

                                            </MenuItem>

                                        ))}


                                    </TextField>


                                </Grid>

                            </Grid>
                            <Divider
                                sx={{
                                    my: 2,
                                    borderColor: "#D1D5DB"
                                }}
                            />
                            {/* <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>

                                <Box
                                    sx={{
                                        p: 3,
                                        borderRadius: 3,
                                        background: "#EEF6FF",
                                        border: "1px solid #D6E8FF"
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            color: "#64748B",
                                            fontSize: "1.3rem",
                                            fontWeight: 500
                                        }}
                                    >
                                        Available Colleges
                                    </Typography>


                                    <Typography
                                        sx={{
                                            mt: 1,
                                            color: "#0B3054",
                                            fontSize: "3rem",
                                            fontWeight: 700
                                        }}
                                    >
                                        {collegeCount}
                                    </Typography>


                                    <Typography
                                        sx={{
                                            color: "#64748B",
                                            fontSize: "1.2rem"
                                        }}
                                    >
                                        Colleges matching your preferences
                                    </Typography>


                                </Box>

                            </Grid>
                            <Grid item xs={12} md={6}>

                                <Box
                                    sx={{
                                        p: 3,
                                        borderRadius: 3,
                                        background: "#FFF7ED",
                                        border: "1px solid #FED7AA"
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            color: "#64748B",
                                            fontSize: "1.3rem",
                                            fontWeight: 500
                                        }}
                                    >
                                        Remaining Modifications
                                    </Typography>


                                    <Typography
                                        sx={{
                                            mt: 1,
                                            color: "#F08021",
                                            fontSize: "3rem",
                                            fontWeight: 700
                                        }}
                                    >
                                        {Math.max(MAX_EDIT - editCount, 0)}
                                    </Typography>


                                    <Typography
                                        sx={{
                                            color: "#64748B",
                                            fontSize: "1.2rem"
                                        }}
                                    >
                                        Filter changes available before PDF generation
                                    </Typography>


                                </Box>

                            </Grid>
                        </Grid> */}

                            {/* <Typography>

                            Available Colleges : {collegeCount}

                        </Typography>
                        <Typography color="primary">

                            Remaining Modifications : {MAX_EDIT - editCount}

                        </Typography> */}
                            <Typography
                                sx={{
                                    fontSize: "1.6rem",
                                    fontWeight: 700,
                                    color: "#242e42",
                                }}
                            >
                                {/* You can modify Branch and City preferences up to <strong>{MAX_EDIT}</strong> times before generating your PDF report. */}
                                ⚠️ Ensure you have selected branches & cities → Click Download List → Only then your list will be emailed.
                            </Typography>
                            <Box
                                sx={{
                                    mt: 4,
                                    display: "flex",
                                    flexDirection: {
                                        xs: "column",
                                        sm: "row",
                                    },
                                    justifyContent: "space-between",
                                    alignItems: {
                                        xs: "stretch",
                                        sm: "center",
                                    },
                                    gap: 2,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 2,
                                        flexDirection: {
                                            xs: "column",
                                            sm: "row",
                                        },
                                    }}
                                >

                                    <Alert
                                        severity={editCount >= MAX_EDIT ? "error" : "info"}
                                        sx={{
                                            mb: 2,
                                            borderRadius: 2,
                                            fontSize: "1.4rem",
                                            color: editCount >= MAX_EDIT ? "#B91C1C" : "#0B3054",
                                            backgroundColor: editCount >= MAX_EDIT ? "#FEE2E2" : "#EEF6FF",
                                        }}
                                    >
                                        Remaining Attempts {Math.max(MAX_EDIT - editCount, 0)}
                                        {/* You can modify Branch and City preferences up to <strong>{MAX_EDIT}</strong> times before generating your PDF report. */}
                                    </Alert>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 2,
                                        flexDirection: {
                                            xs: "column",
                                            sm: "row",
                                        },
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        onClick={handleApplyFilters}
                                        disabled={disableFilters || loadingPrediction}
                                        sx={{
                                            minWidth: 180,
                                            borderRadius: 3,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            fontSize: "1.4rem",
                                            py: 1.2,
                                            borderColor: "#0B3054",
                                            color: "#0B3054",

                                            "&:hover": {
                                                borderColor: "#0B3054",
                                                background: "#EEF6FF"
                                            }
                                        }}
                                    >
                                        {loadingPrediction ? "Applying..." : "Apply Filters"}
                                    </Button>

                                    <Button
                                        ref={downloadPreferenceRef}
                                        variant="contained"
                                        onClick={handleCreatePdf}
                                        sx={{
                                            minWidth: 180,
                                            borderRadius: 3,
                                            py: 1.2,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            fontSize: "1.4rem",
                                            background: canDownloadPdf ? "#16A34A" : "#BDBDBD",
                                            color: '#fff',
                                            "&:hover": {
                                                background: canDownloadPdf ? "#15803D" : "#BDBDBD",
                                            },
                                        }}
                                        disabled={generatingPdf || !canDownloadPdf}
                                    >
                                        {generatingPdf ? "Loading..." : "Download Preference List"}
                                    </Button>
                                </Box>
                            </Box>
                            {sampleColleges.length === 0 ? (
                                <Box
                                    sx={{
                                        py: 6,
                                        textAlign: "center"
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#64748B",
                                            fontFamily: "poppins",
                                            fontSize: "1.3rem"
                                        }}
                                    >
                                        No colleges found for selected filters.
                                    </Typography>
                                </Box>
                            ) : (
                                <Box mt={4}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mb: 2,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "1.8rem",
                                                fontWeight: 700,
                                                color: "#242e42",
                                            }}
                                        >
                                            {/* Sample College Matches */}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#64748B",
                                                fontSize: "1.3rem",
                                            }}
                                        >
                                            Showing {sampleColleges.length} of {collegeCount}
                                        </Typography>
                                    </Box>

                                    {sampleColleges.slice(0, 5).map((college) => (
                                        <Box
                                            key={college.Index}
                                            sx={{
                                                display: "flex",
                                                border: "1px solid #E5E7EB",
                                                borderRadius: 2,
                                                p: 1,
                                                mb: 2,
                                                bgcolor: "#fff",
                                                transition: "0.2s",
                                                "&:hover": {
                                                    boxShadow: 3,
                                                    borderColor: "#0B3054",
                                                },
                                            }}
                                        >
                                            {/* Left Badge */}
                                            <Box
                                                sx={{
                                                    width: 95,
                                                    minWidth: 95,
                                                    bgcolor: "#D9F5FF",
                                                    borderRadius: 1,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    p: 1,
                                                    mr: 2,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "1.4rem",
                                                        fontWeight: 500,
                                                        color: "#2F4858",
                                                    }}
                                                >
                                                    {college.Category}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: "2rem",
                                                        fontWeight: 600,
                                                        color: "#2F4858",
                                                    }}
                                                >
                                                    {college["Highest Rank"]}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: "1.4rem",
                                                        fontWeight: 600,
                                                        color: "#00897B",
                                                    }}
                                                >
                                                    {Number(college["Highest Percentile"]).toFixed(2)}
                                                </Typography>
                                            </Box>

                                            {/* College Details */}
                                            <Box flex={1} sx={{ textAlign: 'left' }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 700,
                                                        fontSize: "1.8rem",
                                                        color: "#242e42",
                                                        textAlign: "left"
                                                    }}
                                                >
                                                    {college.AbbreviatedName || college.College} (
                                                    {college["College Code"]})
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        mt: 0.5,
                                                        fontSize: "1.6rem",
                                                        color: "#242e42",
                                                        textAlign: "left"
                                                    }}
                                                >
                                                    {college.Branch} ({college["Branch Code"]})
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        mt: 0.5,
                                                        fontSize: "1.5rem",
                                                        color: "#242e42",
                                                        textAlign: "left"
                                                    }}
                                                >
                                                    Overall Seats: <b>{college["Seats Cap1"] ?? college.SI}</b>
                                                </Typography>

                                                {/* <Typography
                                                sx={{
                                                    mt: 0.5,
                                                    fontSize: "1.4rem",
                                                    color: "#6B7280",
                                                    textAlign: "left"
                                                }}
                                            >
                                                {college.City}
                                            </Typography> */}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            )
                            }
                            {!canDownloadPdf && (
                                <Typography
                                    sx={{
                                        mb: 1.5,
                                        color: "#D97706",
                                        fontSize: "1.3rem",
                                        fontWeight: 500,
                                    }}
                                >
                                    Only <strong>{collegeCount}</strong> matching{" "}
                                    {collegeCount === 1 ? "college is" : "colleges are"} available with
                                    your current preferences. Try broadening your Branch or City filters
                                    to see more options before downloading your preference list.
                                </Typography>
                            )}
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 2,
                                    flexDirection: {
                                        xs: "column",
                                        sm: "row",
                                    },
                                }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={handleCreatePdf}
                                    sx={{
                                        minWidth: 180,
                                        borderRadius: 3,
                                        py: 1.2,
                                        textTransform: "none",
                                        fontWeight: 600,
                                        fontSize: "1.4rem",
                                        background: canDownloadPdf ? "#16A34A" : "#BDBDBD",
                                        color: '#fff',
                                        "&:hover": {
                                            background: canDownloadPdf ? "#15803D" : "#BDBDBD",
                                        },
                                    }}
                                    disabled={generatingPdf || !canDownloadPdf}
                                >
                                    {generatingPdf ? "Loading..." : "Download Preference List"}
                                </Button>
                                {/* <Typography
                            sx={{
                                mt: 2,
                                textAlign: "center",
                                color: "#64748B",
                                fontSize: "1.3rem"
                            }}
                        >
                            Full list of{" "}
                            <strong>{collegeCount}</strong>{" "}
                            matching colleges will be included in your generated PDF.
                        </Typography> */}

                            </Box>
                        </Box>
                    </CardContent>
                </Card>
                <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={open} onClose={handleClose} autoHideDuration={5000}>
                    <Alert
                        severity={severty} //"error"
                        onClose={handleClose}
                        sx={{
                            width: "100%",
                            fontSize: "15px",
                            ...(severty === "error" && {
                                backgroundColor: "#d32f2f",
                                color: "#fff",
                            }),
                            ...(severty === "warning" && {
                                backgroundColor: "#ed6c02",
                                color: "#fff",
                            }),
                            ...(severty === "success" && {
                                backgroundColor: "#2e7d32",
                                color: "#fff",
                            }),
                            ...(severty === "info" && {
                                backgroundColor: "#0288d1",
                                color: "#fff",
                            }),
                        }}
                    >
                        {showError}
                    </Alert>
                </Snackbar>
            </Box >)
            : (
                <Box
                    sx={{
                        minHeight: "100vh",
                        bgcolor: "#f5f7fb",
                        py: 6,
                    }}

                >
                    <Box textAlign="center" mb={4}>

                        <Typography
                            sx={{
                                fontSize: {
                                    xs: "2.4rem",
                                    md: "3.2rem"
                                },
                                fontWeight: 700,
                                color: "#242e42"
                            }}
                        >
                            No data available
                        </Typography>
                    </Box>
                </Box>
            )
    )
}

export default CollegePredictorReportDashboard
